module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-cove-fluted-hamilton-0.de0d2582.jpg";